import type { ReactNode } from "react";
import { EventStats } from "./_components/event-stats";

export const EventsSharedLayout = ({ children }: { children: ReactNode }) => {
  return (
    <section className="flex flex-col gap-4">
      <EventStats />
      {children}
    </section>
  );
};
